/**
 * Created by ws7s on 2017/3/20.
 */


export default {
    list: []
};